export default __webpack_public_path__ + "static/media/slackicon.55ad9eab.png";